// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileImageTwoToneSvg from "@ant-design/icons-svg/es/asn/FileImageTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileImageTwoTone = function FileImageTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileImageTwoToneSvg
  }));
};

FileImageTwoTone.displayName = 'FileImageTwoTone';
export default React.forwardRef(FileImageTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileImageTwoTone.js
// module id = 1113
// module chunks = 0